import React, { useState } from 'react';
import classNames from 'classnames';
import { CarrelloCombinazioni } from 'features/carrello/carrelloCombinazioni';
import { useGetLabelByKey, useGetLabelsByKeys } from 'hooks/useLingUI';
import styles from './CarrelloCombinazioniDesktop.module.scss';

export const CarrelloCombinazioniDesktop = () => {
  const [labelEspandi, labelRiduci] = useGetLabelsByKeys(['espandi', 'riduci']);
  const [openCombinazioni, setOpenCombinazioni] = useState<boolean>(true);
  const labelCombinazioni = useGetLabelByKey('combinazioni-sistema');

  const handleCloseCombinazioni = () => {
    setOpenCombinazioni(!openCombinazioni);
  };

  return (
    <div className={classNames(styles.wrapper)}>
      <div className={styles.header}>
        <div className={styles.buttonContainer} onClick={handleCloseCombinazioni}>
          <div className={styles.text}>{labelCombinazioni}</div>
          <div className={styles.button} onClick={handleCloseCombinazioni}>
            {openCombinazioni ? labelRiduci : labelEspandi}
          </div>
        </div>
      </div>
      {openCombinazioni && <CarrelloCombinazioni />}
    </div>
  );
};